import type { ApiClientV2Default } from 'utils/api-client/api-client.utils'

export interface AccessibilityTemplate {
  id: number
  generalText: string
  createdAt: string
  updatedAt: string
}

export interface AccessibilityTemplatesCategories {
  id: number
  name_en: string
  name_de: string
  position: boolean
}

const BASE_URL = '/cabinet/accessibility_statement'

export const createAccessibilityTemplateApi = ({ GET, POST, PATCH, DEL }: ApiClientV2Default) => ({
  createAccessibilityStatement: () => POST<AccessibilityTemplatesCategories[]>(`${BASE_URL}`),
  deleteAccessibilityStatement: () => DEL<AccessibilityTemplatesCategories[]>(`${BASE_URL}`),

  fetchStatementOptionPairs: () => GET<AccessibilityTemplatesCategories[]>(`${BASE_URL}/statement_option_pairs`),
  createStatementOptionPair: (data) =>
    POST<AccessibilityTemplatesCategories[]>(`${BASE_URL}/statement_option_pairs`, data),
  updateStatementOptionPair: (id: string, data) =>
    PATCH<AccessibilityTemplatesCategories[]>(`${BASE_URL}/statement_option_pairs/${id}`, data),
  deleteStatementOptionPair: (id: string) =>
    DEL<AccessibilityTemplatesCategories[]>(`${BASE_URL}/statement_option_pairs/${id}`),

  fetchCategories: () => GET<AccessibilityTemplatesCategories[]>(`/cabinet/accessibility_template/categories`),
  fetchOptions: () => GET<AccessibilityTemplatesCategories[]>(`/cabinet/accessibility_template/options`),
})

export type AccessibilityTemplateApi = ReturnType<typeof createAccessibilityTemplateApi>
